'use client'

import CloseIcon from '@mui/icons-material/Close'
import { Box, CircularProgress, IconButton, Stack } from '@mui/material'
import Image from 'next/image'
import { IUploadedMedia } from '../hooks/use-media-upload'

interface IMediaPreviewProps {
  uploadedMedia: IUploadedMedia[]
  onRemoveMedia: (id: string) => void
}

export const MediaPreview = ({ uploadedMedia, onRemoveMedia }: IMediaPreviewProps) => {
  if (uploadedMedia.length === 0) {
    return null
  }

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        p: 2,
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      {uploadedMedia.map((media) => (
        <Box
          key={media.id}
          sx={{
            position: 'relative',
            width: 80,
            height: 80,
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid #e0e0e0',
          }}
        >
          {/* Loading overlay */}
          {media.uploading && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 2,
              }}
            >
              <CircularProgress size={24} sx={{ color: 'white' }} />
            </Box>
          )}

          {/* Media content */}
          {media.type === 'image' ? (
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
              }}
            >
              <Image
                src={media.preview}
                alt="Preview"
                fill
                style={{
                  objectFit: 'cover',
                }}
                unoptimized
              />
            </Box>
          ) : (
            <video
              src={media.preview}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          )}

          {/* Remove button */}
          {!media.uploading && (
            <IconButton
              size="small"
              onClick={() => onRemoveMedia(media.id)}
              sx={{
                position: 'absolute',
                top: 2,
                right: 2,
                bgcolor: 'rgba(0, 0, 0, 0.6)',
                color: 'white',
                width: 20,
                height: 20,
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.8)',
                },
              }}
            >
              <CloseIcon sx={{ fontSize: 14 }} />
            </IconButton>
          )}
        </Box>
      ))}
    </Stack>
  )
}
